<template>
  <div class="report-fs">
    <md-card-content dir="rtl" class="redirect-dir">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card>
            <md-card-header
              style="margin-bottom: 30px"
              class="md-card-header-text md-card-header-green"
            >
              <div class="card-text">
                <h4 class="title">تقرير الموظفين المنتهي خدمتهم</h4>
              </div>
            </md-card-header>

            <div
              style="margin-top: 10px; margin-bottom: 35px"
              class="marginTop"
            >
              <md-card-content>
                <md-table
                  class="paginated-table table-striped table-hover mt-25"
                >
                  <md-table-row>
                    <md-table-cell>ر.م</md-table-cell>

                    <md-table-cell class="w-200">الاسم</md-table-cell>

                    <md-table-cell class="w-100"
                      >نوع إنتهاء الخدمة</md-table-cell
                    >

                    <md-table-cell class="w-200"
                      >تاريخ إنتهاء الخدمة</md-table-cell
                    >

                    <md-table-cell
                      v-if="privateCompanyMode === 'false'"
                      class="w-100"
                      >رقم القرار</md-table-cell
                    >

                    <md-table-cell
                      v-if="
                        privateCompanyMode == 'false' || !privateCompanyMode
                      "
                      class="w-100"
                      >تاريخ القرار</md-table-cell
                    >

                    <md-table-cell class="w-200"
                      >ملاحظة إنتهاء الخدمة</md-table-cell
                    >
                  </md-table-row>
                  <md-table-row v-for="(item, i) in data" :key="i">
                    <md-table-cell md-label="الصنف">{{ i + 1 }}</md-table-cell>

                    <md-table-cell class="w-200" md-label="الصنف">{{
                      item.employeeName
                    }}</md-table-cell>

                    <md-table-cell class="w-100" md-label="الصنف">{{
                      item.typeString
                    }}</md-table-cell>

                    <md-table-cell class="w-200" md-label="الصنف">{{
                      convert(item.endOfServiceDate)
                    }}</md-table-cell>

                    <md-table-cell class="w-100" md-label="الصنف"
                      >{{ item.decisionNumber }}
                    </md-table-cell>

                    <md-table-cell class="w-100" md-label="الصنف"
                      >{{ convert(item.decisionDate) }}
                    </md-table-cell>

                    <md-table-cell class="w-200" md-label="الصنف"
                      >{{ item.cause }}
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </div>
          </md-card>
        </div>
      </div>
    </md-card-content>
  </div>
</template>

<script>
//  import { count } from "console";
import env from "../../../env";

export default {
  mounted() {},
  async created() {
    this.privateCompanyMode = localStorage.getItem("privateCompanyMode");
  },
  props: ["allData", "data"],
  data() {
    return {
      privateCompanyMode: "false",
      currentSort: "",
      currentSortOrder: "asc",
      m: env.mTop(),
    };
  },
  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (event == null) {
          return "";
        }

        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    convertToUi(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return " - ";
        }
        return (
          d.getDate() + " - " + (d.getMonth() + 1) + " - " + d.getFullYear()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
  },
};
</script>
